/* CUSTOMERS */

import BasicLayout from '@/views/layouts/basic.vue';
import customersOverview from '@/views/customers/list.vue';
import customersDetails from '@/views/customers/details.vue';
import customerAddresses from '@/views/customers/addresses/list.vue';
import customerAddressDetails from '@/views/customers/addresses/details.vue';
import customerContacts from '@/views/customers/contacts/list.vue';
import customerContactDetails from '@/views/customers/contacts/details.vue';
import customerQuotes from '@/views/customers/quotes/list.vue';
import customerOrders from '@/views/customers/orders/list.vue';
import customerServices from '@/views/customers/services/list.vue';
import customerService from '@/views/customers/services/details.vue';
import customerPartition from '@/views/customers/partition/details.vue';

/* ROUTER
-------------------------------------------------------------- */
export default {
  path: 'klanten',
  name: 'klanten',
  meta: {title: 'Klanten'},
  redirect: '/klanten/overzicht',
  component: BasicLayout,
  children: [
    // Overview routes
    {
      path: 'overzicht',
      name: 'customers.overview',
      meta: {title: 'Klanten'},
      component: customersOverview,
      children: [
        {
          path: ':status',
          name: 'customers.overview.status',
          meta: {title: 'Klanten'},
          component: customersOverview,
        },
      ],
    },
    // Customer info page
    {
      path: 'toevoegen',
      name: 'customers.add',
      meta: {title: 'Klant'},
      component: customersDetails,
    },
    {
      path: ':id/wijzig',
      name: 'customers.edit',
      meta: {title: 'Klant'},
      component: customersDetails,
    },
    // Address list
    {
      path: ':pid/addresses',
      name: 'customers.addresses.list',
      meta: {title: 'Adressen klant'},
      component: customerAddresses,
    },
    {
      path: ':pid/addresses/toevoegen',
      name: 'customer.address.add',
      meta: {title: 'Klantadres toevoegen'},
      component: customerAddressDetails,
    },
    {
      path: ':pid/address/:addressId/wijzig',
      name: 'customer.address.edit',
      meta: {title: 'Klantadres toevoegen'},
      component: customerAddressDetails,
    },
    // Contact add
    {
      path: ':pid/contacten/toevoegen',
      name: 'customer.contact.add',
      meta: {title: 'Contact toevoegen'},
      component: customerContactDetails,
    },
    // Contacts list
    {
      path: ':pid/contacten',
      name: 'customers.contacts.list',
      meta: {title: 'Contacten klant'},
      component: customerContacts,
      children: [
        // Contacts list by status
        {
          path: ':status',
          name: 'customers.contacts.list.status',
          meta: {title: 'Contacten klant'},
          component: customerContacts,
        },
      ],
    },
    // Contact info/edit page
    {
      path: ':pid/contacten/:contactId/wijzig',
      name: 'customer.contact.edit',
      meta: {title: 'Contact wijzigen'},
      component: customerContactDetails,
    },
    // Quotes list
    {
      path: ':pid/offertes',
      name: 'customers.quotes.list',
      meta: {title: 'Offertes klant'},
      component: customerQuotes,
    },
    // Orders list
    {
      path: ':pid/orders',
      name: 'customers.orders.list',
      meta: {title: 'Orders klant'},
      component: customerOrders,
    },
    // Services list
    {
      path: 'diensten/:pid',
      name: 'customers.services.list',
      meta: {title: 'Diensten klant'},
      component: customerServices,
    },
    {
      path: 'diensten/:pid/dienst/:serviceId',
      name: 'customers.service.edit',
      meta: {title: 'Dienst klant'},
      component: customerService,
    },
    // Partition details
    {
      path: ':customerId/partition',
      name: 'provisioning.partition.info',
      meta: {title: 'Partition klant'},
      component: customerPartition,
    },
  ],
};
